import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageHomeComponent implements OnInit {
    public async ngOnInit() {
        location.href = '/hub';
    }
}

export default PageHomeComponent;